export function roundCurrencyValue(currencyValue: number) {
    return Math.round((currencyValue + Number.EPSILON) * 100) / 100;
}
